export default "__VITE_ASSET__Dyo9RCjr__"